module.exports = __webpack_public_path__ + "static/media/call.caf42056.svg";